import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  const { language } = useLanguage();

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="privacy-policy-page">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#1B3A7B] hover:underline mb-6">
        <ChevronLeft className="w-4 h-4" />
        {language === 'pl' ? 'Powrot do kalkulatora' : 'Back to calculator'}
      </Link>

      <h1 className="text-3xl sm:text-4xl font-heading font-bold text-[#1B3A7B] mb-8">
        {language === 'pl' ? 'Polityka Prywatnosci' : 'Privacy Policy'}
      </h1>

      <div className="prose prose-slate max-w-none space-y-6 text-sm leading-relaxed text-slate-700">
        <p className="text-slate-500 text-xs">Data ostatniej aktualizacji: 15 lutego 2026 r.</p>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">1. Administrator danych osobowych</h2>
          <p>Administratorem danych osobowych jest <strong>Biuro Rachunkowe Kurdynowski</strong> (dalej: &bdquo;Administrator&rdquo;).</p>
          <p>Kontakt z Administratorem: <a href="mailto:monika.gawkowska@kurdynowski.pl" className="text-[#1B3A7B] hover:underline">monika.gawkowska@kurdynowski.pl</a></p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">2. Zakres zbieranych danych</h2>
          <p>W ramach korzystania z serwisu zbieramy nastepujace dane osobowe:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Imie i nazwisko</li>
            <li>Adres e-mail</li>
            <li>Numer telefonu</li>
            <li>Nazwa firmy</li>
            <li>Dane dotyczace wyceny uslug ksiegowych (forma ksiegowosci, liczba dokumentow, liczba pracownikow)</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">3. Cele przetwarzania danych</h2>
          <p>Dane osobowe przetwarzane sa w nastepujacych celach:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Przygotowanie i przekazanie wyceny uslug ksiegowych (art. 6 ust. 1 lit. b RODO)</li>
            <li>Kontakt w sprawie przedstawienia oferty (art. 6 ust. 1 lit. a RODO &mdash; zgoda)</li>
            <li>Realizacja prawnie uzasadnionych interesow Administratora, w tym marketing bezposredni (art. 6 ust. 1 lit. f RODO)</li>
            <li>Wypelnienie obowiazkow prawnych ciacych na Administratorze (art. 6 ust. 1 lit. c RODO)</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">4. Okres przechowywania danych</h2>
          <p>Dane osobowe beda przechowywane przez okres niezbedny do realizacji celow, dla ktorych zostaly zebrane, a po tym czasie przez okres wymagany przepisami prawa lub do momentu wycofania zgody.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">5. Prawa osoby, ktorej dane dotycza</h2>
          <p>Przysuguja Panstwu nastepujace prawa:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Prawo dostepu do danych</li>
            <li>Prawo do sprostowania danych</li>
            <li>Prawo do usuniecia danych (&bdquo;prawo do bycia zapomnianym&rdquo;)</li>
            <li>Prawo do ograniczenia przetwarzania</li>
            <li>Prawo do przenoszenia danych</li>
            <li>Prawo do sprzeciwu wobec przetwarzania</li>
            <li>Prawo do wycofania zgody w dowolnym momencie</li>
            <li>Prawo do wniesienia skargi do Prezesa Urzedu Ochrony Danych Osobowych</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">6. Udostepnianie danych</h2>
          <p>Dane osobowe moga byc udostepniane podmiotom wspolpracujacym z Administratorem w zakresie niezbednym do realizacji uslug, w tym dostawcom uslug IT, hostingu, poczty elektronicznej.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">7. Bezpieczenstwo danych</h2>
          <p>Administrator stosuje odpowiednie srodki techniczne i organizacyjne zapewniajace bezpieczenstwo przetwarzanych danych osobowych, w tym ochrone przed nieuprawnionym dostepem, utrata lub zniszczeniem.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">8. Kontakt</h2>
          <p>W sprawach zwiazanych z ochrona danych osobowych prosimy o kontakt pod adresem: <a href="mailto:monika.gawkowska@kurdynowski.pl" className="text-[#1B3A7B] hover:underline">monika.gawkowska@kurdynowski.pl</a></p>
        </section>
      </div>
    </div>
  );
}
